import React, { useState } from 'react';
import Button from './Button';
import { currencySigns } from '../utils/currencies';

function OfferForm({ onSubmit, onClose, selectedCurrency }) {
    const [email, setEmail] = useState('');
    const [price, setPrice] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !price) {
            setError('Please fill in all fields.');
            return;
        }
        setError('');
        onSubmit({ email, price, currency: selectedCurrency });
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded shadow-lg w-full max-w-md relative">
                <Button
                    type="button"
                    title="×"
                    styles="absolute top-2 right-2 text-gray-500 hover:text-black text-2xl px-2 py-0 min-w-0"
                    onClick={onClose}
                    aria-label="Close"
                />
                <h2 className="text-2xl mb-4 font-semibold">Make an Offer</h2>
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <input
                        type="email"
                        className="border p-2 rounded"
                        placeholder="Your email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                    />
                    <div className="flex items-center">
                        {/* Another button option */}
                        {/* <input
                            type="number"
                            className="border p-2 rounded"
                            placeholder={`Your offer (${currencySigns[selectedCurrency]})`}
                            value={price}
                            onChange={e => setPrice(e.target.value)}
                            min="1"
                            required
                        /> */}

                        <input
                            type="number"
                            className="border p-2 rounded w-32"
                            placeholder="Your offer"
                            value={price}
                            onChange={e => setPrice(e.target.value)}
                            min="1"
                            required
                        />
                        <span className="ml-2 text-lg">{currencySigns[selectedCurrency]}</span>
                    </div>
                    {error && <div className="text-red-500 text-sm">{error}</div>}
                    <Button
                        type="submit"
                        title="Submit Offer"
                        styles="bg-black text-white py-2 rounded hover:bg-gray-800 transition"
                    />
                </form>
            </div>
        </div>
    );
}

export default OfferForm;